import { Box, Button } from "@mui/material";
import { FallbackProps } from "react-error-boundary";
import PageContainer from "./PageContainer";

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  return (
    <PageContainer>
      <main
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4.8rem",
        }}
      >
        <Box
          sx={{
            border: "1px solid red",
            borderRadius: 3,

            padding: "4.8rem",
            flex: "0 1 96rem",
            textAlign: "center",
          }}
        >
          <Box component="h1">خطایی رخ داده است 🧐</Box>
          <p>{error.message}</p>
          <Button size="large" onClick={resetErrorBoundary}>
            تلاش مجدد
          </Button>
        </Box>
      </main>
    </PageContainer>
  );
}

export default ErrorFallback;
